<template>
  <div class="card card-margin" :class="[type && `card-${type}`]">
    <div v-if="$slots.image" class="card-image">
      <slot name="image"></slot>
    </div>
    <div
      v-if="$slots.header || title"
      class="card-header"
      :class="headerClasses"
    >
      <div class="header-content">
        <slot name="header">
          <h3 class="card-title" style="min-width: 200px;">{{ title }}</h3>
          <div class="ms-auto d-flex align-items-center gap-2">
            <span v-if="onCancel" @click.stop="onCancel">
              <i class="material-icons card-icon">close</i>
            </span>
            <span v-if="onCustomMethod && customMethodIconWithCounter !== ''" class="card-icon-counter" :data-count="customMethodIconCounter" @click.stop="onCustomMethod">
              <i class="material-icons card-icon">{{ customMethodIconWithCounter }}</i>
            </span>
            <span v-if="onCustomMethod && customMethodIconWithCounter === ''" class="d-flex align-items-center" @click.stop="onCustomMethod">
              <img v-if="customMethodImage !== ''" :src="customMethodImage" alt="app-logo" class="erp-logo"/>
              <i :class="[{ spin: customMethodIconSpin }]" class="material-icons card-icon">{{customMethodIcon}}</i>
            </span>
            <span v-if="!onCustomMethod && customMethodImage !== ''" class="d-flex align-items-center">
              <img :src="customMethodImage" alt="app-logo" class="erp-logo"/>
            </span>
            <span v-if="onAddObject" @click.stop="onAddObject">
              <i class="material-icons card-icon">add</i>
            </span>
          </div>
          <p v-if="subTitle" class="card-category">{{ subTitle }}</p>
        </slot>
        <slot name="header-extra"></slot> <!-- New slot for additional header content -->
        <slot v-if="!isMobile" name="table-select" class="col-sm d-flex justify-content-end"></slot> <!-- New slot for table selection buttons -->
      </div>
      <slot name="under-header"></slot> <!-- Slot for content directly beneath the title row -->
      <slot v-if="isMobile" name="table-select" class="col-sm d-flex justify-content-end"></slot> <!-- New slot for table selection buttons -->
    </div>
    <div v-if="$slots.default" class="card-body">
      <slot></slot>
    </div>
    <div v-if="$slots['image-bottom']" class="card-image">
      <slot name="image-bottom"></slot>
    </div>
    <slot name="raw-content"></slot>
    <div v-if="$slots.footer" class="card-footer" :class="footerClasses">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "Card",
  props: {
    title: {
      type: String,
      default: '',
      description: "Card title",
    },
    subTitle: {
      type: String,
      default: '',
      description: "Card subtitle",
    },
    type: {
      type: String,
      default: '',
      description: "Card type (e.g primary/danger etc)",
    },
    headerClasses: {
      type: [String, Object, Array],
      default: '',
      description: "Card header css classes",
    },
    bodyClasses: {
      type: [String, Object, Array],
      default: '',
      description: "Card body css classes",
    },
    footerClasses: {
      type: [String, Object, Array],
      default: '',
      description: "Card footer css classes",
    },
    onCancel: {
      type: Function,
      default: null,
    },
    onAddObject: {
      type: Function,
      default: null,
    },
    onCustomMethod: {
      type: Function,
      default: null,
    },
    customMethodIcon: {
      type: String,
      default: '',
    },
    customMethodImage: {
      type: String,
      default: '',
    },
    customMethodIconSpin: {
      type: Boolean,
      default: false,
    },
    customMethodIconWithCounter: {
      type: String,
      default: '',
    },
    customMethodIconCounter: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isMobile: window.innerWidth <= 1024
    }
  },
  created() {
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    handleCancel() {
      if (this.onCancel) {
        this.onCancel();
      }
    },
    handleAddObject() {
      if (this.onAddObject) {
        this.onAddObject();
      }
    },
    handleCustomMethod() {
      if (this.onCustomMethod) {
        this.onCustomMethod();
      }
    },
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    }
  }
};
</script>
<style scoped>
.card-margin {
  margin: 20px;
}
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-icon {
  font-size: 32px;
  cursor: pointer;
  color: var(--primary-color);
}
.big-icon {
  font-size: 25px;
}
.erp-logo
{
  height: 25px;
  padding-right: 5px;
}

.card-icon-counter {
  position: relative;
  display: inline-flex;
  cursor: pointer;
}

.card-icon-counter[data-count]:after {
  position: absolute;
  right: -4px;
  top: -4px;
  content: attr(data-count);
  font-size: 11px;
  padding: 0.25em 0.45em;
  border-radius: 999px;
  line-height: 1;
  color: white;
  background: red;
  text-align: center;
  min-width: 1.4em;
  font-weight: bold;
}

.spin {
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

</style>
